import React from 'react';
import { AlertTriangle, Info } from 'lucide-react';
import { Badge } from '../components/ui/badge';

function WeekRow({ w }) {
  var cls = w.is_over ? 'bg-red-50 border-l-4 border-red-400' : '';
  var gekuerzt = (w.gekuerzt_monatsgrenze || 0) > 0;
  return (
    <div className={'py-2 px-3 rounded-lg ' + cls} data-testid={'week-summary-' + w.iso_week}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-sm font-medium text-slate-700" translate="no">{w.label}</span>
          {w.spans_months && (
            <span className="text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded">monatsübergreifend</span>
          )}
        </div>
        <div className="flex items-center gap-3 text-sm flex-shrink-0">
          <span className="text-slate-500">
            <span translate="no">{w.erfasst}</span> / <span translate="no">{w.bewilligt}</span> Std.
          </span>
          <span className="text-slate-400">anr. <span translate="no">{w.anrechenbar}</span></span>
          {w.is_over && (
            <Badge className="bg-red-100 text-red-700 gap-1" data-testid={'week-warning-' + w.iso_week}>
              <AlertTriangle className="h-3 w-3" /><span translate="no">+{w.mehrstunden}</span>
            </Badge>
          )}
        </div>
      </div>
      {gekuerzt && (
        <p className="mt-1 text-xs text-slate-500" data-testid={'week-gekuerzt-' + w.iso_week}>
          Diese Woche läuft über den Monatswechsel: <span translate="no">{w.anrechenbar}</span> von{' '}
          <span translate="no">{w.bewilligt}</span> Std. sind in
          diesem Monat anrechenbar, <span translate="no">{w.gekuerzt_monatsgrenze}</span> Std. entfallen (im Nachbarmonat
          bereits abgerechnet).
        </p>
      )}
    </div>
  );
}

export function WeeklyBreakdown({ weeks, totalBillable, hasOvertime }) {
  if (!weeks || weeks.length === 0) return null;

  var rows = [];
  for (var i = 0; i < weeks.length; i++) {
    rows.push(<WeekRow key={weeks[i].iso_week} w={weeks[i]} />);
  }

  return (
    <div className="space-y-1" data-testid="weekly-breakdown">
      <div className="flex items-center justify-between px-3 mb-1">
        <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Wochenübersicht</h4>
        <span className="text-xs text-slate-500">Anrechenbar: <strong className="text-slate-700"><span translate="no">{totalBillable}</span> Std.</strong></span>
      </div>
      <div className="space-y-0.5">{rows}</div>
    </div>
  );
}

export function OvertimeAlert() {
  return (
    <div className="flex items-start gap-3 p-3 rounded-lg bg-red-50 border border-red-200" data-testid="overtime-alert">
      <AlertTriangle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-red-800">
        <strong>Achtung:</strong> In einer oder mehreren Wochen überschreitest du die bewilligten Stunden.
        Abgerechnet wird höchstens das bewilligte Wochenbudget – bei Wochen über den Monatswechsel auch
        weniger, wenn die Stunden im Nachbarmonat schon abgerechnet wurden. Deine erfassten Stunden
        bleiben vollständig erhalten. Das Backoffice wird beim Einreichen informiert.
      </div>
    </div>
  );
}
